<script setup>
import { computed } from 'vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import { isEmailInbox } from 'dashboard/constants/gch';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const colorClass = computed(() =>
  isEmailInbox(props.inbox)
    ? 'bg-n-blue-3 text-n-blue-11'
    : 'bg-n-teal-3 text-n-teal-11'
);
</script>

<template>
  <span
    v-tooltip.top="{
      content: inbox.name,
      delay: { show: 500, hide: 0 },
    }"
    class="grid place-content-center size-6 rounded-md flex-shrink-0"
    :class="colorClass"
  >
    <ChannelIcon :inbox="inbox" class="size-3.5" />
  </span>
</template>
